
    import { commonWebStorage } from '@/Utils/CommonWebStorage';
    export default {
        emits: ['close'],
        props: {
            storageKey: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                dismissed: false,
            };
        },
        mounted() {
            const stored = commonWebStorage.get(this.storageKey);
            this.dismissed = !!stored;
        },
        methods: {
            close(...args) {
                commonWebStorage.add(this.storageKey, true);
                this.dismissed = true;
                this.$emit('close', ...args);
            },
        },
        render() {
            if (this.dismissed || !this.$slots.default) return null;

            return this.$slots.default?.({ close: this.close });
        },
    };
